import React from "react";
import { FaEnvelope } from "react-icons/fa";
import "./Header.css";
import logo from "../../assets/images/logo.png";

function Header() {
  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="Logo NEXUS SOLUTIONS" className="logo-img" />
        <div className="logo-texts">
          <span className="logo-text">NEXUS SOLUTIONS</span>
          <span className="logo-tagline">📍 Cocody, Angré, Cité des Racines</span>
        </div>
      </div>
      <div className="header-contact">
        <a href="mailto:contact@nxs-solutions.com" className="header-phone">
          <FaEnvelope size={13} />
          contact@nxs-solutions.com
        </a>
        {/* <a href="https://wa.me/2250142578758" target="_blank" rel="noopener noreferrer" className="header-wa">
          <FaWhatsapp size={15} />
          WhatsApp
        </a> */}
      </div>
    </header>
  );
}

export default Header;
